import { ApiCall } from "components/common/services/ApiServices";
import {
  BASIC_DETAILS,
  GENERAL_DETAILS,
  GET_COMPANY_RELATED_DETAILS,
  OFFICE_ADDRESS_DATA,
  SET_DROPDOWN_DATA,
  UPDATE_FIELDS,
  UPDATE_TAB_DATA,
} from "../../annotation/PlanningConstants";
import { COMPANY_MICROSERVICE } from "Constants";
import { FormatPCList } from "components/common/utlis/FormatPCList";
import { fetchCoeffDetails } from "./SetCoeffData";
import { setParitarCommitteDropdown } from "./helper";
import CustomNotify from "components/common/atoms/CustomNotify";
import { t } from "components/CentralDataMangement/translation/Translation";

export const fetchCompanyDetails = async (
  type: "company" | "branch", // Dynamic type handling
  id: number | null | undefined | string,
  dispatch: React.Dispatch<any>,
  mode: string = "create",
  office?: any
) => {
  const data = { type, id, mode };

  if (id) {
    const response = await ApiCall.service(
      `${GET_COMPANY_RELATED_DETAILS}`,
      "POST",
      data,
      false,
      COMPANY_MICROSERVICE
    );
    if (response?.status === 200) {
      const responseData = response?.data;
      if (type === "company") {
        const dropdownOptions = {
          branchOptions: responseData?.branchOptions || [],
          pcOptions: FormatPCList(responseData?.pcOptions) || [],
          pcLists: FormatPCList(responseData?.pcOptions, true) || [],
          commercialProfileOptions:
            responseData?.commercialProfileOptions || [],
          pcCommercialProfileOptions:
            responseData?.commercialProfileOptions || [],
          timeTableOptions: responseData?.timeTableOptions || [],
          timeTableOptionsWithCoopAgreeId: responseData?.timeTableOptions || [],
          payProfileOptions: responseData?.payProfileOptions || [],
          pcPayProfileOptions: responseData?.payProfileOptions || [],
        };

        dispatch({ type: SET_DROPDOWN_DATA, payload: dropdownOptions });

        //Set the pc according to the office
        office && setParitarCommitteDropdown(office, dropdownOptions.pcLists, dispatch)

        const fieldsToUpdate = ["partiarCommittee", "branch"];
        fieldsToUpdate.forEach((field) => {
          if (responseData[field]) {
            dispatch({
              type: UPDATE_FIELDS,
              tab: BASIC_DETAILS,
              field: field,
              value: responseData[field], // Access the correct value dynamically
            });
          }
        });
      }
      // Handle branchDetails
      if (responseData.branchDetails && Object.keys(responseData.branchDetails).length > 0) {
        const branchDetail = responseData.branchDetails;
        dispatch({
          type: UPDATE_TAB_DATA,
          tab: OFFICE_ADDRESS_DATA,
          data: branchDetail,
        });
      }
    }else{
      CustomNotify({
        type: "error",
        message: t("Some error occured")
      });
    }
  }
};

export const setPlanningProfileRelatedFields = (
  profileId: number | null | undefined,
  state: any,
  dispatch: React.Dispatch<any>
) => {
  if (profileId) {
    //selected profile option
    const profileOption = state.dropDowndata.commercialProfileOptions.find(
      (option: any) => option.value === profileId
    );

    const pcOption = state.dropDowndata.pcOptions.find(
      (option: any) => option.value === profileOption.pcId
    );
    dispatch({
      type: UPDATE_FIELDS,
      tab: BASIC_DETAILS,
      field: "partiarCommittee",
      value: pcOption,
    });
    setPCRelatedDetails(pcOption.value, state, dispatch); //adjust dropdown values for pay and commercial profile
    //empType for selected profile
    const empTypeOption = state.dropDowndata.empTypes.find(
      (option: any) => option?.value === profileOption.empTypeId
    );

    fetchCoeffDetails("coeff", empTypeOption.value, dispatch);

    //function name for selected profile
    const functionName = profileOption.functionName ?? "";
    if(state.internalInfoDetails.formStatus !== 1){
      dispatch({
          type: UPDATE_FIELDS,
          tab: BASIC_DETAILS,
          field: "employeeType",
          value: empTypeOption,
        });
    }
    
    dispatch({
      type: UPDATE_FIELDS,
      tab: BASIC_DETAILS,
      field: "function",
      value: functionName,
    });
  }
};

export const setPCRelatedDetails = (
  pcId: number | null | undefined,
  state: any,
  dispatch: React.Dispatch<any>,
) => {
  if (pcId) {
    if (
      state.dropDowndata?.commercialProfileOptions &&
      state.dropDowndata.commercialProfileOptions.length > 0
    ) {
      //options for commercial profile
      const filteredCommercialProfileOptions =
        state.dropDowndata.commercialProfileOptions.filter(
          (option: any) => option.pcId === pcId
        );

      //options for pay profile
      // let filteredPayProfileOptions = [];
      // if (state.basicDetails.planningProfile) {
      //   filteredPayProfileOptions =
      //     state.dropDowndata.payProfileOptions.filter(
      //       (option: any) => option.pcId === pcId && option.agreementId == state.basicDetails.planningProfile.agreementId
      //     );
      // } else {
      //   filteredPayProfileOptions =
      //     state.dropDowndata.payProfileOptions.filter(
      //       (option: any) => option.pcId === pcId
      //     );
      // }

      const pc = state.dropDowndata.pcLists.find((option: any) => option?.value == pcId);
      const filteredEmpTypes = state.dropDowndata.empTypes.filter((option: any) => {
        return option?.type === pc?.type
      });
      const dropdownOptions = {
        pcCommercialProfileOptions: filteredCommercialProfileOptions,
        // pcPayProfileOptions: filteredPayProfileOptions,
        employeeTypeOptions: filteredEmpTypes
      };

      dispatch({ type: SET_DROPDOWN_DATA, payload: dropdownOptions });
    }
  }
};
